import { useEffect, useState } from "react";
import { getDataAPI } from "../utils/fetchData";
import DataTable from "./datatable";
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const Skilldevelopement = () => {
	const [body, setBody] = useState([]);
	const [selfBody, setselfBody] = useState([]);
	const [grandtotal, setGrandTotal] = useState(0);
	const [selfGrandTotal, setSelfGrandTotal] = useState(0);

	const headers = [
		{
			prop: "serial_number",
			title: "S.No.",
			// isSortable: true,
			isFilterable: true,
		},
		{
			prop: "course_name",
			title: "Course Name",
			// isSortable: true,
			isFilterable: true,
		},
		{
			prop: "standard",
			title: "Standard",
			// isSortable: true,
			isFilterable: true,
		},
		{
			prop: "client_organization",
			title: "Client Organization",
			// isSortable: true,
			isFilterable: true,
		},
		{
			prop: "category",
			title: "Trainee Category",
			// isSortable: true,
			isFilterable: true,
		},
		{
			prop: "from_date",
			title: "From",
			isFilterable: true,
		},
		{
			prop: "to_date",
			title: "To",
			isFilterable: true,
		},
		{
			prop: "state",
			title: "State",
			// isSortable: true,
			isFilterable: true,
			cellProps: {
				style: (row) => ({
					maxWidth: "200px",
				}),
			},
		},
		{
			prop: "total_participants",
			title: "Total Participants",
			// isSortable: true,
			isFilterable: true,
		},
	];

	const selfHeaders = [
		{
			prop: "number",
			title: "S.No.",
			isSortable: true,
			isFilterable: true,
		},
		{
			prop: "courseTitle",
			title: "Course Name",
			isSortable: true,
			isFilterable: true,
		},
		{
			prop: "total",
			title: "Total Participants",
			isSortable: true,
			isFilterable: true,
		},
	];

	useEffect(() => {
		getDataAPI("getAllSkillDevelopments").then((res) => {
			if (res.data && Array.isArray(res.data.skills)) {
				setBody(res.data.skills);
				setGrandTotal(res.data.totalParticipants);
			}
		});
		getDataAPI("getCount").then((res) => {
			console.log("res", res.data);
			setselfBody(res.data.courseregisters);
			setSelfGrandTotal(res.data.grandtotal);
		});
	}, []);

	// Sort body by order before passing to DataTable
	const sortedBody = [...body].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

	return (
		<>
			<Navbar />
			<Homecarousel />
			<div className="tab-m">
				<div id="Tab">
					<ul className="nav1 nav-tabs1">
						<li className="active pb-dl">
							<a href="#1" data-toggle="tab">
								Instructor Led Courses
							</a>
						</li>
						<li>
							<a href="#2" data-toggle="tab">
								Self Paced Courses
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div className="tab-content ">
				<div className="tab-pane active" id="1">
					<div className="mt-4 mx-4">
						✅ <strong>Skill Development:</strong> Search and view your
						completed courses, categorized by standard or by organization, all
						in one place.
					</div>
					<div className="table-responsive" style={{ padding: "30px" }}>
						<DataTable
							headers={headers}
							body={sortedBody}
							grandtotal={grandtotal}
							initialSort={[]}
						/>
					</div>
				</div>
				<div className="tab-pane" id="2">
					<div className="table-responsive" style={{ padding: "30px" }}>
						<DataTable
							headers={selfHeaders}
							body={selfBody}
							grandtotal={selfGrandTotal}
						/>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};
export default Skilldevelopement;
